const CONSENT_KEY = "sp-analytics-consent";

export type ConsentState = "granted" | "denied" | "pending";

export function getConsent(): ConsentState {
	if (typeof window === "undefined") {
		return "pending";
	}
	const value = localStorage.getItem(CONSENT_KEY);
	if (value === "granted" || value === "denied") {
		return value;
	}
	return "pending";
}

export function setConsent(state: "granted" | "denied"): void {
	localStorage.setItem(CONSENT_KEY, state);
	window.dispatchEvent(new CustomEvent("consent-changed", { detail: state }));
}

export function clearConsent(): void {
	localStorage.removeItem(CONSENT_KEY);
	window.dispatchEvent(
		new CustomEvent("consent-changed", { detail: "pending" }),
	);
}
